import { render, staticRenderFns } from "./umum.vue?vue&type=template&id=30f359e8&"
import script from "./umum.vue?vue&type=script&lang=js&"
export * from "./umum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports